import React, { useState } from 'react';
import { Button, Form, Input, Upload } from 'antd';
import AppShell from './components/AppShell';
import Panel from './components/Panel';
import axiosInstance from './utils/axiosInstance';
import { errorDialog } from './utils/dialog';
import { PlusOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import type { GetProp, UploadFile, UploadProps } from 'antd';
import { useNavigate } from 'react-router-dom';

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

const getBase64 = (file: FileType): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });

const NewProductPage: React.FC = () => {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [file, setFile] = useState<UploadFile>();
    const [fileUrl, setFileUrl] = useState('');
    const navigate = useNavigate();

    const addProduct = async (name: string, seller: string, price: number, img: string) => {
        try {
            const response = await axiosInstance.post("admin/protected/addProduct", {
                name,
                seller,
                price,
                img
            })
            if (response?.data) {
                navigate('/product');
            } else {
                errorDialog();
            }

        } catch (error: any) {
            console.error('Error fetching data:', error);
            if (error?.response?.status === 401) {
                navigate('/login');  // Redirect to login if unauthorized
            }
        }
    };

    const onFinish = async (values: any) => {
        console.log('Received values of form: ', values, fileUrl);
        if (fileUrl) {
            addProduct(values.name, values.seller, values.price, fileUrl);
        }
    };

    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as FileType);
        }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
    };

    const handleChange: UploadProps['onChange'] = (info) => {
        let file = info.file;
        setFile(file);
        let url = file?.response?.file?.path;
        setFileUrl(url);
    }

    const uploadButton = (
        <button className="border-0 bg-transparent text-muted transition-colors hover:text-brand" type="button">
            <PlusOutlined />
            <div className="mt-2">上传</div>
        </button>
    );

    return (
        <AppShell
            title="新建"
            subtitle="商品"
            actions={<Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/product')}>返回</Button>}
        >
            <div className="mx-auto max-w-[460px]">
                <Panel>
                    <Form
                        name="login"
                        layout="vertical"
                        requiredMark={false}
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name="name"
                            label="名称"
                            rules={[{ required: true, message: '请输入名称' }]}
                        >
                            <Input placeholder="名称" />
                        </Form.Item>
                        <Form.Item
                            name="seller"
                            label="卖家"
                            rules={[{ required: true, message: '请输入卖家' }]}
                        >
                            <Input placeholder="卖家" />
                        </Form.Item>
                        <Form.Item
                            name="price"
                            label="价钱"
                            rules={[{ required: true, message: '请输入价钱' }]}
                        >
                            <Input placeholder="价钱" type='number' />
                        </Form.Item>

                        <Form.Item label="图片">
                            <Upload
                                action={`${process.env.REACT_APP_API_URL}/upload`}
                                listType="picture-circle"
                                fileList={file ? [file] : []}
                                onPreview={handlePreview}
                                onChange={handleChange}
                            >
                                {file ? null : uploadButton}
                            </Upload>
                        </Form.Item>

                        <Form.Item className="!mb-0 !mt-6">
                            <Button block size="large" type="primary" htmlType="submit">
                                创建
                            </Button>
                        </Form.Item>
                    </Form>
                </Panel>
            </div>
        </AppShell>
    );
}

export default NewProductPage;